import Vue from 'vue'
import Router from 'vue-router'

import Hello from '@/components/Hello'
import Login from '@/components/Login'
import AdminLogin from '@/components/AdminLogin'
import SignUp from '@/components/SignUp'
import Impressum from '@/components/Impressum'
import Help from '@/components/Help'
import Gallery from '@/components/Gallery'
import UploadContainer from '@/components/Upload/UploadContainer'

import firebase from 'firebase/app'

Vue.use(Router)

let router = new Router({
  mode: 'history',
  routes: [
    {
      path: '*',
      redirect: '/login'
    },
    {
      path: '/',
      redirect: '/login'
    },
    {
      path: '/login',
      name: 'Login',
      component: Login
    },
    {
      path: '/admin-login',
      name: 'AdminLogin',
      component: AdminLogin
    },
    {
      path: '/sign-up',
      name: 'SignUp',
      component: SignUp
    },
    {
      path: '/hello',
      name: 'Hello',
      component: Hello,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/gallery/:gal/:page',
      name: 'Galerie',
      component: Gallery,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/gallery/:gal/:page/:img',
      name: 'GalerieImage',
      component: Gallery,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/preupload',
      name: 'PreUpload',
      component: UploadContainer,
      meta: {
        requiresAuth: true
      }
    },
    {
      path: '/impressum',
      name: 'Impressum',
      component: Impressum
    },
    {
      path: '/help',
      name: 'Help',
      component: Help,
      meta: {
        requiresAuth: true
      }
    }
  ]
})

router.beforeEach((to, from, next) => {
  let currentUser = firebase.auth().currentUser
  let requiresAuth = to.matched.some(record => record.meta.requiresAuth)
  if (requiresAuth && !currentUser) {
    console.log('needs auth')
    next('/login')
  } else {
    next()
  }
})

export default router



// WEBPACK FOOTER //
// ./src/router/index.js